/**
 * Converts a programmatic identifier (camelCase, snake_case, kebab-case) into a
 * Title Case display label suitable for table headers, chart legends, and
 * detail-panel labels.
 *
 * @example
 * humanizeKey('production_rate')   // 'Production Rate'
 * humanizeKey('camelCaseValue')    // 'Camel Case Value'
 * humanizeKey('kebab-case-key')    // 'Kebab Case Key'
 * humanizeKey('SE0074_L_avg')      // 'SE0074 L Avg' (acronyms preserved)
 */
export function humanizeKey(key: string): string {
  return key
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/[_-]/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
